


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// src/pages/Dashboard.js
import React, { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";
import axios from "axios";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";



const Dashboard = () => {
  const [token, setToken] = useState("");
  const [response, setResponse] = useState(null);
  const auth = getAuth();
  const [userId, setUserId] = useState("");
  const [prompt, setPrompt] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedModel, setSelectedModel] = useState("Llama3.2");
  const [billingData, setBillingData] = useState(null);
  const [apiKey, setApiKey] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [billingDataGpt, setBillingDataGpt] = useState(null);
  const [billingDataDeepseek, setBillingDataDeepseek] = useState(null);
  const [showExamples, setShowExamples] = useState(false);



  const navigate = useNavigate();

  // guard and fetch user once
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (!user) {
        return navigate("/login");
      }
      setUserEmail(user.email);
    });
    return unsubscribe;
  }, []);


  useEffect(() => {
    const fetchBillingInfo = async () => {
      try {
        const idToken = await auth.currentUser.getIdToken();
        // const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/subscription-info`, {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/subscription-info-llama`, {
          headers: { Authorization: `Bearer ${idToken}` }
        });
        setBillingData(res.data);
      } catch (error) {
        console.error("Failed to fetch billing info", error);
      }
    };
    if (userEmail) fetchBillingInfo();
  }, [userEmail]);


  // 🔹 GPT-OSS subscription info
  useEffect(() => {
    const fetchGptInfo = async () => {
      try {
        const idToken = await auth.currentUser.getIdToken();
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/subscription-info-gpt-oss`, {
          headers: { Authorization: `Bearer ${idToken}` }
        });
        setBillingDataGpt(res.data);
      } catch (error) {
        console.error("Failed to fetch GPT-OSS billing info", error);
      }
    };
    if (userEmail) fetchGptInfo();
  }, [userEmail]);

  // 🔹 DeepSeek subscription info
  useEffect(() => {
    const fetchDeepseekInfo = async () => {
      try {
        const idToken = await auth.currentUser.getIdToken();
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/subscription-info-deepseek`, {
          headers: { Authorization: `Bearer ${idToken}` }
        });
        setBillingDataDeepseek(res.data);
      } catch (error) {
        console.error("Failed to fetch DeepSeek billing info", error);
      }
    };
    if (userEmail) fetchDeepseekInfo();
  }, [userEmail]);


  // sign‑out handler:
  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const handleGenerateToken = async () => {

    try {
      const user = auth.currentUser;
      if (user) {
        const idToken = await user.getIdToken(true);
        setToken(idToken);
        setUserId(user.email);
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/protected`,
          {},
          { headers: { Authorization: `Bearer ${idToken}` } }
        );
        setResponse(res.data);
      }
    } catch (error) {
      console.error(error);
    }

  };



  const handleGenerateApiKey = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) throw new Error('Not logged in');
      const idToken = await user.getIdToken();

      const response = await axios.post(
        // 'http://localhost:8000/generate-api-key',
        `${process.env.REACT_APP_API_BASE_URL}/generate-api-key`,

        {},
        {
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );

      setApiKey(response.data.api_key);
      setShowPopup(true);
    } catch (error) {
      alert('Error generating API key:' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDisableApiKeys = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) throw new Error('Not logged in');
      const idToken = await user.getIdToken();

      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/disable-api-key`,
        {
          headers: { Authorization: `Bearer ${idToken}` },
        }
      );

      alert('All API keys disabled.');
    } catch (error) {
      alert('Error deleting API keys: ' + error.message);
    } finally {
      setLoading(false);
    }
  };


  // Decide if the current user has an active subscription for a given model
  const hasActiveSubscription = (model) => {
    const isActive = (subData) =>
      subData &&
      subData.subscription &&
      subData.subscription.status === "active";

    if (model === "Llama3.2") {
      return isActive(billingData);
    } else if (model === "gpt-oss20b") {
      return isActive(billingDataGpt);
    } else if (model === "deepseekr1") {
      return isActive(billingDataDeepseek);
    }

    return false;
  };



  const handleQuery = async () => {
    setLoading(true);
    setResponse(""); // reset previous response
    const user = auth.currentUser;
    if (!user) return;

    try {
      // ✅ Check subscription before hitting backend
      if (!hasActiveSubscription(selectedModel)) {
        setResponse(
          "Your subscription for this model is not active."
        );
        setLoading(false);
        return;
      }

      const idToken = await user.getIdToken();


      let endpoint = "";
      if (selectedModel === "Llama3.2") {
        endpoint = "/llama-query";
      } else if (selectedModel === "gpt-oss20b") {
        endpoint = "/gpt-oss-query";
      } else if (selectedModel === "deepseekr1") {
        endpoint = "/deepseek-query";
      }

      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`
        },
        body: JSON.stringify({ prompt })
      });


      //       else if (selectedModel === 'gpt-oss20b') {
      //   const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/gpt-oss-query`, {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${idToken}`
      //     },
      //     body: JSON.stringify({ prompt })
      //   });
      // }


      // else if (selectedModel === 'deepseekr1') {
      //   const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/deepseek-query`, {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${idToken}`
      //     },
      //     body: JSON.stringify({ prompt })
      //   });
      // }





      if (!res.ok) {
        // Handle non-stream errors
        const errData = await res.json().catch(() => ({}));
        // setResponse(`Error: ${errData.detail || res.statusText}`);

        if (res.status === 403) {
          setResponse(errData.detail || "No active subscription for this model.");
        } else if (res.status === 429) {
          setResponse(errData.detail || "Daily limit reached for this plan.");
        } else {
          setResponse(`Error: ${errData.detail || res.statusText}`);
        }
        return;
        // return;
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let accumulated = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        accumulated += chunk;
        setResponse(prev => prev + chunk); // update UI as chunks arrive
      }

    } catch (err) {
      setResponse(`Error: ${err.message}`);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



  // const handleLlamaQuery = async () => {
  //   setLoading(true);
  //   const user = auth.currentUser;
  //   if (user) {
  //     try {
  //       const idToken = await user.getIdToken();
  //       const res = await axios.post(
  //         // "http://localhost:8081/llama-query",
  //         "http://localhost:8000/llama-query",
  //         { prompt },
  //         { headers: { Authorization: `Bearer ${idToken}` } }
  //       );
  //       setResponse(res.data.message.content);
  //       setUserId(user.email);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //     setLoading(false);
  //   }
  // };


  const handleSubscribe = async (planType) => {
    try {
      const idToken = await auth.currentUser.getIdToken();
      // const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/create-subscription`,
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/create-subscription`,
        { plan_type: planType },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      window.location.href = res.data.subscription_url; // redirect to Razorpay
    } catch (err) {
      alert(err.response.data.detail || "An error occurred while creating subscription.");
      console.error(err);
    }
  };

  const handleCancelSubscription = async (planType) => {
    try {
      const idToken = await auth.currentUser.getIdToken();
      // await axios.post(`${process.env.REACT_APP_API_BASE_URL}/cancel-subscription`, {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/cancel-subscription?plan_type=${planType}`, {
        // subscription_id: billingData.subscription_id
      }, {
        headers: { Authorization: `Bearer ${idToken}` }
      });
      alert("Subscription canceled");
      setBillingData(null);
    } catch (error) {
      console.error(error);
    }
  };




  return (

    // <div className="min-h-screen bg-gray-50 p-6">
    //   <div className="max-w-15xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Centered page title */}
      <h1 className="text-3xl font-bold text-center mb-8">
        Welcome to your Dashboard!
      </h1>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">

        {/* Billing Card - Left */}
        <div className="bg-white shadow rounded-lg p-6 md:col-span-1 space-y-4">
          {/* <button
            onClick={handleSubscribe}
            className="mt-2 px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
          >
            Subscribe
          </button> */}
          <div className="bg-white shadow-lg rounded-lg p-6 md:col-span-1">
            <h2 className="text-xl font-semibold mb-4">Subscriptions</h2>
            <div className="flex space-x-3 mb-1">
              <button
                onClick={() => handleSubscribe("llama")}
                // className="mt-2 px-4 py-1 bg-purple-600 text-sm text-white rounded hover:bg-purple-700 "
                className="mt-2 px-4 py-1 bg-purple-300 text-purple-800 hover:bg-purple-400 text-sm rounded "
              >
                Subscribe Llama 3.2
              </button>
              <button
                onClick={() => handleCancelSubscription("llama")}
                // className="mt-2 px-4 py-1 bg-red-600 text-sm text-white rounded hover:bg-red-700"
                className="mt-2 px-4 py-1 bg-red-300 text-red-800 hover:bg-red-400 text-sm rounded "
              >
                Cancel Llama 3.2
              </button>
            </div>
            {/* <h2 className="text-xl font-semibold mb-2">Billing Information</h2> */}
            {billingData ? (
              <>
                <h3>Subscription ID: {billingData.subscription_id}</h3>
                <p>Status: {billingData.subscription.status}</p>
                {billingData.customer ? (
                  <p>Email: {billingData.customer.email}</p>
                ) : (
                  <p>No Razorpay customer yet</p>
                )}

              </>
            ) : (
              <p>Loading subscription data…</p>
            )}
          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 md:col-span-1">
            <div className="flex space-x-3 mb-3">
              <button
                onClick={() => handleSubscribe("gpt-oss")}
                // className="mt-2 px-4 py-1 bg-blue-600 text-sm text-white rounded hover:bg-blue-700 "
                className="mt-2 px-4 py-1 bg-blue-300 text-blue-800 hover:bg-blue-400 rounded"
              >
                Subscribe GPT-OSS
              </button>
              <button
                onClick={() => handleCancelSubscription("gpt-oss")}
                // className=" mt-2 px-4 py-1 bg-red-600 text-sm text-white rounded hover:bg-red-700"
                className=" mt-2 px-4 py-1 bg-red-300 text-red-800 hover:bg-red-400 text-sm rounded "
              >
                Cancel GPT-OSS
              </button>
            </div>
            {billingDataGpt ? (
              <>
                <h3>Subscription ID: {billingDataGpt.subscription_id}</h3>
                <p>Status: {billingDataGpt.subscription.status}</p>
                {billingDataGpt.customer ? (
                  <p>Email: {billingDataGpt.customer.email}</p>
                ) : (
                  <p>No Razorpay customer yet</p>
                )}
              </>
            ) : (
              <p>Loading GPT-OSS subscription data…</p>
            )}

          </div>

          <div className="bg-white shadow-lg rounded-lg p-6 md:col-span-1">
            <div className="flex space-x-3 mb-3">
              <button
                onClick={() => handleSubscribe("deepseek")}
                // className="mt-2 px-4 py-1 bg-green-600 text-sm text-white rounded hover:bg-green-700 "
                className="mt-2 px-4 py-1 bg-green-300 text-sm text-green-800 hover:bg-green-400 rounded"
              >
                Subscribe DeepSeek R1
              </button>
              <button
                onClick={() => handleCancelSubscription("deepseek")}
                // className="mt-2 px-4 py-1 bg-red-600 text-sm text-white rounded hover:bg-red-700"
                className="mt-2 px-4 py-1 bg-red-300 text-red-800 hover:bg-red-400 text-sm rounded "
              >
                Cancel DeepSeek R1
              </button>
            </div>


            {/* <h2 className="text-xl font-semibold mb-2">Billing Information</h2> */}
            {billingDataDeepseek ? (
              <>
                <h3>Subscription ID: {billingDataDeepseek.subscription_id}</h3>
                <p>Status: {billingDataDeepseek.subscription.status}</p>
                {billingDataDeepseek.customer ? (
                  <p>Email: {billingDataDeepseek.customer.email}</p>
                ) : (
                  <p>No Razorpay customer yet</p>
                )}
              </>
            ) : (
              <p>Loading DeepSeek subscription data…</p>
            )}
          </div>

          {/*<button
            onClick={handleCancelSubscription}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Cancel Subscription
          </button>*/}

          {/* <div className="space-y-2 mt-4">
            <button
              onClick={() => handleCancelSubscription("llama")}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Cancel Llama 3.2
            </button>
            <button
              onClick={() => handleCancelSubscription("gpt-oss")}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Cancel GPT-OSS
            </button>
            <button
              onClick={() => handleCancelSubscription("deepseek")}
              className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            >
              Cancel DeepSeek R1
            </button>
          </div> */}
        </div>

        {/* Dashboard + Llama - Right side */}
        <div className="space-y-6 md:col-span-2">
          {/* Token Card */}
          {/* <div className="bg-white shadow-lg rounded-lg p-6">
            <h1 className="text-2xl font-bold mb-4">Welcome to your Dashboard!</h1> */}


          <div className="bg-white shadow-lg rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">API Key Management</h2>
            <div className="space-x-4">
              {/* <button
              onClick={handleGenerateToken}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Generate Access Token
            </button> */}
              <button
                onClick={handleGenerateApiKey}
                disabled={loading}
                className="px-4 py-2 bg-blue-300 text-blue-800 hover:bg-blue-400 rounded"
              >
                {"Generate API Key"}
              </button>
              <button
                onClick={handleDisableApiKeys}
                disabled={loading}
                className="px-4 py-2 bg-red-300 text-red-800 rounded hover:bg-red-400 rounded"
              >
                {"Disable All API Keys"}
              </button>
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => setShowExamples(true)}
                className="px-3 py-2 text-sm bg-purple-100 text-purple-800 rounded hover:bg-purple-200"
              >
                API Examples
              </button>
            </div>
          </div>



          {/* {token && (
              <div className="mt-4">
                <h2 className="text-lg font-medium">Generated Token:</h2>
                <textarea
                  value={token}
                  readOnly
                  rows={5}
                  className="w-full border border-gray-300 rounded p-2 mt-2"
                />
              </div>
            )} */}
          {/* </div> */}

          {/* Llama Query Card */}
          <div className="bg-white shadow-lg rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <label htmlFor="model" className="text-xl font-semibold">
                Select Model
              </label>
              <select
                id="model"
                value={selectedModel}
                onChange={(e) => setSelectedModel(e.target.value)}
                className="border border-gray-300 rounded px-2 py-1"
              >
                <option value="Llama3.2">Llama 3.2 Latest</option>
                <option value="gpt-oss20b">GPT-OSS 20B</option>
                <option value="deepseekr1">DeepSeek R1</option>
                {/* <option value="DeepSeek R1">DeepSeek R1</option> */}
              </select>
            </div>

            <textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              rows={4}
              className="w-full border border-gray-300 rounded p-2 mb-4"
              placeholder="Enter your prompt here..."
            />
            <button
              onClick={handleQuery}
              disabled={loading}
              className="px-4 py-2 bg-green-300 text-green-800 rounded hover:bg-green-400"
            >
              {loading
                ? "Generating…"
                : `Send to ${selectedModel === "Llama3.2"
                  ? "Llama 3.2"
                  : selectedModel === "gpt-oss20b"
                    ? "GPT-OSS 20B"
                    : "DeepSeek R1"
                }`}
            </button>

            {/* <button
              onClick={handleSubmit}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Submit
            </button> */}


            {response && (
              <div className="mt-6 bg-gray-100 p-4 rounded">
                <h3 className="font-medium">User: {userId}</h3>
                <pre className="whitespace-pre-wrap mt-2">{response}</pre>
              </div>
            )}
          </div>
        </div>
      </div>
      {
        showPopup && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
              <h3 className="text-lg font-semibold mb-2">Your API Key</h3>
              <code className="block mb-4 p-2 bg-gray-100 rounded text-sm break-words">{apiKey}</code>
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-900"
              >
                Close
              </button>
            </div>
          </div>
        )
      }
      {showExamples && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">Quick API Examples</h3>
              <button
                onClick={() => setShowExamples(false)}
                className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
              >
                Close
              </button>
            </div>

            <div className="space-y-4 text-sm">
              {/* cURL */}
              <div className="border rounded-lg p-3 bg-gray-50">
                <div className="font-semibold text-indigo-600 mb-1">cURL</div>
                <pre className="text-xs bg-black text-green-100 rounded p-3 overflow-x-auto">
                  {`curl -N -X POST "https://api.elephantrohck.com/llama-query" \
  -H "Content-Type: application/json" \
  -H "X-API-Key: YOUR_API_KEY" \
  -d '{
    "prompt": "Hello from SlickAPI"
  }'`}
                </pre>
              </div>

              {/* Python */}
              <div className="border rounded-lg p-3 bg-gray-50">
                <div className="font-semibold text-indigo-600 mb-1">Python</div>
                <pre className="text-xs bg-black text-green-100 rounded p-3 overflow-x-auto">
                  {`import requests

url = "https://api.elephantrohck.com/llama-query"
headers = {
    "X-API-Key": "YOUR_API_KEY",
    "Content-Type": "application/json",
}
data = {"prompt": "Hello from SlickAPI"}

response = requests.post(url, json=data, headers=headers, stream=True)

for chunk in response.iter_content(chunk_size=None):
    if chunk:
        print(chunk.decode(), end="")`}
                </pre>
              </div>

              {/* JavaScript (Node) */}
              <div className="border rounded-lg p-3 bg-gray-50">
                <div className="font-semibold text-indigo-600 mb-1">JavaScript (Node)</div>
                <pre className="text-xs bg-black text-green-100 rounded p-3 overflow-x-auto">
                  {`import fetch from "node-fetch";

const url = "https://api.elephantrohck.com/llama-query";

const response = await fetch(url, {
  method: "POST",
  headers: {
    "X-API-Key": "YOUR_API_KEY",
    "Content-Type": "application/json",
  },
  body: JSON.stringify({ prompt: "Hello from SlickAPI" }),
});

for await (const chunk of response.body) {
  process.stdout.write(chunk.toString());
}`}
                </pre>
              </div>
            </div>
          </div>
        </div>
      )}

    </div >

  );
};

export default Dashboard;